import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NearDatesWithPrice } from '../models';
import {HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig} from "../config/hotel-tours-list-page.config";

@Injectable()
export class NearDatesWithPriceService {
  constructor(
      @Inject(HOTEL_TOURS_PAGE_CONFIG) private hotelToursPageConfig: HotelToursPageConfig,
      private http: HttpClient,
  ) { }

  getNearDatesWithPrice(dateFrom: string, departCityId: number, countryId: number): Observable<NearDatesWithPrice[]> {
    const params = new HttpParams()
        .set('dateFrom', dateFrom.toString())
        .set('departCityId', departCityId.toString())
        .set('countryId', countryId.toString());
    return this.http.get<NearDatesWithPrice[]>('/findForm/getNearDatesWithPriceForToursNotFoundBlock', { params });
  }
}
